import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangDeIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M.559 12.13a9.003 9.003 0 0 0 16.88 0l-8.44-.782-8.44.782Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.999 0a9.003 9.003 0 0 0-8.44 5.87l8.44.782 8.44-.782A9.003 9.003 0 0 0 8.999 0Z",
				fill: "#000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M.56 5.87A8.98 8.98 0 0 0 0 9c0 1.1.198 2.155.56 3.13h16.88A8.98 8.98 0 0 0 18 9a8.98 8.98 0 0 0-.56-3.13H.56Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h18v18H0z"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgLangDeIconmin);
export { ForwardRef as ReactComponent };
